<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        التقارير
        <v-spacer></v-spacer>
        <SearchReport :trainingCenterId="trainingCenter" @clicked="onSearch" />
      </v-card-title>
      <v-data-table :headers="headers" :items="receipt" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <!-- <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon @click="dialog = false">
              <DeleteStudentPayment :dataToDelete="item" @reloadTask="initialData()" v-if="$store.state.userData.roleId == 1" />
            </v-btn>
          </template> -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import SearchReport from "./report/SearchReport.vue";
export default {
  components: {
    SearchReport,
  },
  props: {
    trainingCenter: Number,
  },
  data: () => ({
    overlay: false,
    search: "",
    showAddPayment: false,
    studentId: "",
    courseId: "",
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "تاريخ الدفعة", value: "studentReceiptDateFormat" },
      { text: "المبلغ", value: "amount" },
      { text: "بواسطة", value: "userName" },
      { text: "الموظف", value: "employeeName" },
      { text: "الملاحظات", value: "notes" },
    ],
    currencies: [],
    receipt: [],
    courses: [],
    employees: [],
    studentPayments: [],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;
      self.showAddPayment = false;

      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrl}/studentReceiptsByTrainingCenter/${self.trainingCenter}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrl}/courseTrainingCenter/${self.trainingCenter}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrl}/employees`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((receipt, courses, employees) => {
            self.receipt = receipt.data;
            self.courses = courses.data;
            self.employees = employees.data;

            self.overlay = false;
          })
        )
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },
    onSearch(value) {
      console.log(value);
    },
    allStudentPayments() {
      let self = this;
      self.$http
        .get(`${self.$store.state.apiUrl}/studentPaymentsForCourse?studentId=${self.studentId}&courseId=${self.courseId}`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          self.studentPayments = res.data;
        });
    },
    searchPayment(value) {
      let self = this;
      console.log(value);
      self.studentPayments = value.data;
      self.studentId = value.studentId;
      self.courseId = value.courseId;
      self.showAddPayment = true;
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.resources.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.sectionName.toLowerCase().includes(v));
        });
      } else {
        return this.resources;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
